/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstatusarchived2Inputs */

const en_dropstatusarchived2 = /** @type {(inputs: Dropstatusarchived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const de_dropstatusarchived2 = /** @type {(inputs: Dropstatusarchived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Dropstatusarchived2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstatusarchived2 = /** @type {((inputs?: Dropstatusarchived2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstatusarchived2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstatusarchived2(inputs)
	return de_dropstatusarchived2(inputs)
});
export { dropstatusarchived2 as "dropStatusArchived" }